<template>
  <div class="container">
    <div class="row">
      <div class="col">
        <h3 class="text-center">
          <span style="padding: 0 12px;border-left:1px solid;border-right:1px solid;">{{ $t('series.title') }}</span>
        </h3>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <b-breadcrumb style="background-color: transparent;">
          <b-breadcrumb-item :to="{ name: 'index' }">{{ $t('index.title') }}</b-breadcrumb-item>
          <b-breadcrumb-item>{{ $t('series.title') }}</b-breadcrumb-item>
          <b-breadcrumb-item>{{ $t('series.list.recently-updated.title') }}</b-breadcrumb-item>
          <b-breadcrumb-item :to="{ name: 'updated-series' }">{{ $t('series.list.recently-updated.updated.title') }}</b-breadcrumb-item>
        </b-breadcrumb>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <b-nav pills fill>
          <b-nav-item :to="{ name: 'live-streaming-series' }" v-if="$i18n.locale === 'tw'">{{ $t('series.livestream-list.title') }}</b-nav-item>
          <b-nav-item :to="{ name: 'ongoing-series' }" active>{{ $t('series.list.title') }}</b-nav-item>
        </b-nav>
      </div>
    </div>
    <b-overlay :show="is_loading" rounded="sm" opacity="0.6">
      <div class="row mt-3">
        <div class="col">
          <b-nav pills fill>
            <b-nav-item-dropdown :text="$t('series.list.recently-updated.title')" toggle-class="active">
              <b-dropdown-item :to="{ name: 'ongoing-series' }">{{ $t('series.list.recently-updated.ongoing.title') }}</b-dropdown-item>
              <b-dropdown-item :to="{ name: 'recently-added-series' }">{{ $t('series.list.recently-updated.recently-added.title') }}</b-dropdown-item>
              <!-- <b-dropdown-item :to="{ name: 'updated-series' }" active>{{ $t('series.list.recently-updated.updated.title') }}</b-dropdown-item> -->
            </b-nav-item-dropdown>
            <b-nav-item :to="{ name: 'classified-series' }">{{ $t('series.list.classified.title') }}</b-nav-item>
            <b-nav-item :to="{ name: 'series-search' }">{{ $t('series.list.search.title') }}</b-nav-item>
          </b-nav>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-12">
          <h3>{{ $t('series.list.recently-updated.updated.title') }}</h3>
        </div>
        <div class="col-md-6 col-12" v-for="series in series_with_episodes_updated">
          <b-card no-body class="overflow-hidden" border-variant="dark">
            <b-row no-gutters>
              <b-col>
                <b-card-body :title="`${series.title_name} ${series.title_no}`" :sub-title="series.lecr_name">
                  <b-button
                    squared
                    variant="outline-primary"
                    target="_blank"
                    :to="{ name: 'series', params: { series_no: series.title_no } }"
                  >{{ $t('series.list.button.introduction.label') }}</b-button>
                  <!-- <b-button
                    squared
                    variant="outline-danger"
                    target="_blank"
                    :href="`https://www.youtube.com/results?search_query=${ series.title_name }`"
                  ><b-icon icon="youtube"></b-icon> Youtube</b-button> -->
                  <b-button
                    squared
                    variant="success"
                    @click="playLatestEpisode(series)"
                  >{{ $t('series.list.recently-updated.updated.button.watch-latest-episode.label') }} <b-icon icon="play"></b-icon></b-button>
                  <b-card-text>{{ $t('series.list.recently-updated.updated.label.updated-date') }}：{{ series.latest_filedate.substr(0, 10) }}</b-card-text>
                </b-card-body>
              </b-col>
            </b-row>
          </b-card>
        </div>
      </div>
      <template #overlay>
        <div class="text-center">
          <b-icon icon="arrow-clockwise" font-scale="5" animation="spin-pulse"></b-icon>
        </div>
      </template>
    </b-overlay>
    <b-modal
      centered
      size="lg"
      id="audiovisual-player"
      :title="series ? `${series.title_name} ${series.title_no}` : ''"
    >
      <series-audiovisual-player
        :episodes="episodes"
        :currently_playing_episode_index="currently_playing_episode_index"
      ></series-audiovisual-player>
      <template #modal-footer="{ close }">
        <b-button class="w-100" variant="default" @click="close()">{{ $t('modal.button.close.label') }}</b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
import Vue from 'vue'

import lodash from 'lodash'

import { stringify } from 'query-params-helpers'
import { BreadcrumbPlugin } from 'bootstrap-vue'
import { ButtonPlugin } from 'bootstrap-vue'
import { CardPlugin } from 'bootstrap-vue'
import { DropdownPlugin } from 'bootstrap-vue'
import { IconsPlugin } from 'bootstrap-vue'
import { LinkPlugin } from 'bootstrap-vue'
import { ModalPlugin } from 'bootstrap-vue'
import { NavPlugin } from 'bootstrap-vue'
import { OverlayPlugin } from 'bootstrap-vue'

import SeriesAudiovisualPlayer from '@/components/players/SeriesAudiovisualPlayer'

import i18n from '@/plugins/i18n.js'

import SeriesApiService from '@/services/budaedu-api-services/series-api-service.js'

Vue.use(lodash)
Vue.use(BreadcrumbPlugin)
Vue.use(ButtonPlugin)
Vue.use(CardPlugin)
Vue.use(DropdownPlugin)
Vue.use(IconsPlugin)
Vue.use(LinkPlugin)
Vue.use(ModalPlugin)
Vue.use(NavPlugin)
Vue.use(OverlayPlugin)

Vue.use(SeriesApiService)

export default {
  i18n,
  name: 'updated-series',
  data() {
      return {
        is_loading: false,
        filter: {
          IsDirtyEntry: 'N'
        },
        series_with_episodes_updated: [],
        series: null,
        episodes: [],
        currently_playing_episode_index: 0
      }
  },
  methods: {
    async playLatestEpisode(series) {
      await this.setAudiovisualPlayer(series)
      this.currently_playing_episode_index = this.episodes.length - 1
      this.$bvModal.show('audiovisual-player')

      gtag('event', `watch series online`, {
        code: this.series.title_no,
        name: this.series.title_name
      })
    },
    async setAudiovisualPlayer(series) {
      let items = await this.$seriesApiService.fetchEpisodes(series, 'order=AV_fileorder,asc')
      this.episodes = items.data
      this.series = series
    },
    getFilter() {
      let filter = { IsDirtyEntry: 'N' }
      if (this.$i18n.locale === 'en') {
        filter.cag_no = 'C016,C025,C036'
      }
      return filter
    },
    async setSeriesWithEpisodesUpdated() {
      this.is_loading = true
      this.series_with_episodes_updated = []
      try {
        const additional = stringify({ filter: this.getFilter() }).substr(1)
        let items = await this.$seriesApiService.getWithEpisodesUpdated(20, additional)
        this.series_with_episodes_updated = items.data
      } finally {
        this.is_loading = false
      }
    }
  },
  async created() {
      //alert(`Vue version : ${Vue.version}`);
      await this.setSeriesWithEpisodesUpdated()
  },
  components: {
    SeriesAudiovisualPlayer
  },
  metaInfo() {
    return {
      title: `${this.$t('series.list.title')}-${this.$t('series.list.recently-updated.updated.title')}`,
      meta: [{
        vmid: 'description',
        name: 'description',
        content: ''
      }]
    }
  }
}
</script>